import * as swcHelpers from '@swc/helpers';

const toOrderDetailPrice = (raw)=>{
    return {
        totalPrice: raw.total,
        shippingMethodPrice: raw.shippingPrice,
        paymentMethodPrice: raw.paymentMethodPrice || undefined,
        discountedAmount: raw.discountedAmount || 0,
        subtotalAmount: raw.subtotal || 0
    };
};
const toAddress = (raw)=>{
    if (!raw) {
        return undefined;
    }
    const fieldNames = [
        'firstName',
        'lastName',
        'streetName',
        'streetNumber',
        'additionalStreetInfo',
        'city',
        'postalCode',
        'region',
        'countryCode',
        'externalId', 
    ];
    if (raw.__typename === 'OrderAddress') {
        var _fieldName;
        return fieldNames.reduce((m, fieldName)=>swcHelpers.objectSpread({}, m, {
                [fieldName]: (_fieldName = raw[fieldName]) !== null && _fieldName !== void 0 ? _fieldName : ''
            })
        , {});
    }
};

export { toAddress, toOrderDetailPrice };
//# sourceMappingURL=orders.js.map
